export function getInitials(name: string) {
    const parts = name.split(' ').filter(Boolean);
    const initials = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : name.slice(0, 2);
    return initials.toUpperCase();
}
